import { Component, OnInit } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { AngularRoutes, EnumNames, Invoice, InvoiceStatus, Payout, PayoutFrequencyEnum, PayoutStatusEnum } from '@parkupp/core'
import { firstValueFrom } from 'rxjs'
import { InvoiceService } from 'src/app/services/invoice.service'
import { MerchantService } from 'src/app/services/merchant.service'
import { PayoutService } from 'src/app/services/payout.service'

@Component({
    selector: 'app-admin-payout-details',
    templateUrl: './admin-payout-details.component.html',
    styleUrls: ['./admin-payout-details.component.scss'],
})
export class AdminPayoutDetailsComponent implements OnInit {
    PayoutStatusEnum = PayoutStatusEnum
    EnumNames = EnumNames
    PayoutFrequencyEnum = PayoutFrequencyEnum
    InvoiceStatus = InvoiceStatus
    AngularRoutes = AngularRoutes
    payout: Payout
    payoutKey: string
    invoices: Invoice[] = []
    busyDeleting = false
    constructor(private payoutService: PayoutService, private route: ActivatedRoute, private invoiceService: InvoiceService, private merchantService: MerchantService) {}

    async ngOnInit() {
        this.payoutKey = this.route.snapshot.params['payoutKey']
        this.payout = await this.payoutService.getPayout(this.payoutKey)

        console.log(this.payout.invoiceRefs)
        this.invoices = await this.invoiceService.getInvoicesByInvoiceRefs(this.payout.invoiceRefs as any)
        console.log(this.invoices)

        this.invoices.forEach(async (invoice) => {
            if (invoice.merchantRef) {
                invoice.$merchant = await this.merchantService.getMerchant(invoice.merchantRef.id)
            }
        })
    }

    async deletePayout() {
        this.busyDeleting = true
        console.log('Deleting payout', this.payoutKey)
        const confirm = window.confirm('Are you sure you want to delete this payout?')
        if (confirm) {
            await this.payoutService.deletePayout(this.payoutKey)
            location.reload()
        }
    }
}
